import type { CollectionGroup, CollectionSlide } from '@collection-player/types/collection-player.type'

const cache = new Map<string, string>()

const has = (key: string) => cache.has(key)
const set = (key: string, value: string) => cache.set(key, value)
const get = (key: string) => cache.get(key)
const remove = (key: string) => cache.delete(key)
export const clear = () => cache.clear()

export function useCacheNavigation(nodeId: string) {
  const createCacheId = (id: CollectionGroup['id'] | CollectionSlide['id']) => `${nodeId}:${id}`

  return {
    set,
    has,
    get,
    remove,
    clear,
    createCacheId,
  }
}
